import React, { useState, useEffect } from "react";
import Navbar from "../../../components/Navbar";
import SideBar from "../../../components/SideBar";
import Select from "react-select";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import {GetServiceCaller,DeleteServiceCaller} from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { Modal, Button, Form } from "react-bootstrap";
import HTMLComponent from "../../../components/HtmlComponent";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const BankList = () => {
  const navigate = useNavigate();
  const [bankList, setBankList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [locationOption, setLocationOption] = useState([]);
  console.log("locationOption", locationOption);
  const [jobTitleOption, setJobtitleOption] = useState([]);
  console.log("jobTitleOption", jobTitleOption);
  const [statusOption, setStatusOption] = useState([]);
  console.log("statusOption", statusOption);

  const columns = {
    Code: { text: "Code", align: "center", visible:true },
    Name: { text: "Name", align: "center", visible:true },
    BranchCode: { text: "Branch Code", align: "center", visible:true },
    IFSCCode: { text: "IFSC Code", align: "center", visible:true },
    MICRCode: { text: "MICR Code", align: "center", visible:true },
    Active: { text: "Active", align: "center", visible:true },
  };
  const defaultColumns = {
    Code: true,
    Name: true,
    BranchCode: true,
    IFSCCode: true,
    MICRCode: true,
    Active: true,
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Bank List"))
  }, [])

 
  useEffect(() => {
    fetchBank();
  }, []);

  const fetchBank = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}bank`);
      if (response?.status === 200) {
        const cleanedData = response?.data?.banks;
        setBankList(cleanedData);
        setLoading(false);
      } else {
        console?.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response?.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  const handleEdit = (item)=>{
   navigate('/edit-bank/'+item.ID); 
  }
  const handleDelete = async(item)=>{
    try {
      const response = await DeleteServiceCaller(
        `${API_URL}bank/${item.ID}`,[],'delete'
      );
      toast.success(response?.data?.msg);
      fetchBank();
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  }
  const handleAdd = ()=>{
    navigate('/add-bank');
  }
 

 
  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="crad rounded bg-white" id="skill-table-area">
        
            <div className="row mt-2">
              <Dynamic_PR_table
                isAddNewButtonRequired={true}
                data={bankList}
                isActionRequired={true}
                columns={columns}
                defaultColumns={defaultColumns}
                itemsPerPage={10}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                isSorting={true}
                showIcon1={true}
                showIcon2={true}
                showIcon3={true}
                handleIcon1={handleEdit}
                handleIcon2={handleDelete}
                icons={{
                  Icon1: <i className="bi bi-pencil-square icons"></i>,
                  Icon1Text:'Edit',
                  Icon2: <i className="bi bi-trash icons"></i>,
                  Icon2Text:'Delete',
                }}
                isFilteredRequired={false}
                handleAddNew={handleAdd}
                isAddNewBtnRequired={true}
              />
            </div>
          </div>
        </div>
       
    </>
  );
};

export default BankList;
